/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_Other_PlaceholderInputs */

const en_us2_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your answer`)
};

const pt_br2_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva a sua resposta`)
};

const es_419_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe tu respuesta`)
};

const pt_pt2_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreve a tua resposta`)
};

const fr_fr2_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écris ta réponse`)
};

const de_de2_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Antwort`)
};

const it_it2_coach_extra_ask_other_placeholder = /** @type {(inputs: Coach_Extra_Ask_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi la tua risposta`)
};

/**
* | output |
* | --- |
* | "Type your answer" |
*
* @param {Coach_Extra_Ask_Other_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_other_placeholder = /** @type {((inputs?: Coach_Extra_Ask_Other_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_Other_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_other_placeholder(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_other_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_other_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_other_placeholder(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_other_placeholder(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_other_placeholder(inputs)
	return en_us2_coach_extra_ask_other_placeholder(inputs)
});
export { coach_extra_ask_other_placeholder as "coach-extra.ask_other_placeholder" }